export class JsonPatchDocumentGenerator {
    private _patchDocument: any[] = []

    public getJsonPatchDocument(oldValue: any, newValue: any, ignoreFields: string[]): any[] {
        this._patchDocument = []
        if (oldValue === undefined || newValue === undefined) {
            return []
        }
        const oldVal = JSON.parse(JSON.stringify(oldValue))
        const newVal = JSON.parse(JSON.stringify(newValue))
        const keysOldVal = Object.keys(oldVal)
        const keysNewVal = Object.keys(newVal)
        for (const key of ignoreFields) {
            if (keysOldVal.includes(key)) {
                delete oldVal[key]
            }
            if (keysNewVal.includes(key)) {
                delete newVal[key]
            }
        }
        this.compareObjects(oldVal, newVal, "")
        return this._patchDocument
    }

    private serielizeObjectAndAdd(object: any, path: string) {
        if (object !== null && object !== undefined && typeof object === "object") {
            // The container has to exist before its members can be added: JSON Patch applies each op against
            // the document as it stands, so "add /a/b/0" fails if nothing ever created /a/b.
            this._patchDocument.push({ op: "add", path, value: Array.isArray(object) ? [] : {} })
            if (Array.isArray(object)) {
                for (let i = 0; i < object.length; i++) {
                    this.serielizeObjectAndAdd(object[i], `${path}/${i}`)
                }
            } else {
                for (const key of Object.keys(object)) {
                    this.serielizeObjectAndAdd(object[key], `${path}/${key}`)
                }
            }
        } else {
            this._patchDocument.push({ op: "add", path, value: object })
        }
    }

    private serielizeObjectAndRemove(object: any, path: string) {
        if (object === null) {
            this._patchDocument.push({ op: "remove", path })
        } else if (typeof object === "object") {
            if (Array.isArray(object)) {
                for (let i = 0; i < object.length; i++) {
                    this.serielizeObjectAndRemove(object[i], `${path}/${i}`)
                }
            } else {
                for (const key of Object.keys(object)) {
                    this.serielizeObjectAndRemove(object[key], `${path}/${key}`)
                }
            }
        } else {
            this._patchDocument.push({ op: "remove", path })
        }
    }

    private compareObjects(oldVal: any, newVal: any, path: string) {
        if (typeof oldVal === "object" && typeof newVal === "object") {
            if (Array.isArray(oldVal) && Array.isArray(newVal)) {
                if (newVal.length < oldVal.length) {
                    for (let i = oldVal.length - 1; i >= newVal.length; i--) {
                        this._patchDocument.push({ op: "remove", path: `${path}/${i}` })
                    }
                } else if (newVal.length > oldVal.length) {
                    for (let i = oldVal.length; i < newVal.length; i++) {
                        const newItem = newVal[i]
                        if (newItem !== null && typeof newItem === "object" && !Array.isArray(newItem)) {
                            this._patchDocument.push({ op: "add", path: `${path}/${i}`, value: {} })
                        } else {
                            this._patchDocument.push({ op: "add", path: `${path}/${i}`, value: newItem })
                        }
                    }
                }

                for (let i = 0; i < newVal.length; i++) {
                    const isNewSlot = i >= oldVal.length
                    const newItem = newVal[i]
                    const isObjectElement = newItem !== null && typeof newItem === "object" && !Array.isArray(newItem)
                    if (isNewSlot && !isObjectElement) {
                        continue
                    }
                    const oldItem = isNewSlot ? {} : oldVal[i]
                    if (JSON.stringify(oldItem) !== JSON.stringify(newItem)) {
                        this.compareObjects(oldItem, newItem, `${path}/${i}`)
                    }
                }
                return
            } else if (Array.isArray(oldVal)) {
                this._patchDocument.push({ op: "replace", path, value: newVal })
            } else if (Array.isArray(newVal)) {
                this._patchDocument.push({ op: "remove", path })
                this._patchDocument.push({ op: "add", path, value: newVal })
            } else {
                if (oldVal === null && newVal === null) {
                    return
                } else if (oldVal === null && newVal !== null) {
                    if (typeof newVal === "object") {
                        this._patchDocument.push({ op: "add", path, value: newVal })
                    } else {
                        this._patchDocument.push({ op: "replace", path, value: newVal })
                    }
                    return
                } else if (oldVal !== null && newVal === null) {
                    this._patchDocument.push({ op: "replace", path, value: null })
                    return
                } else {
                    for (const key of Object.keys(oldVal)) {
                        if (!newVal.hasOwnProperty(key)) {
                            this.serielizeObjectAndRemove(oldVal[key], `${path}/${key}`)
                        } else {
                            this.compareObjects(oldVal[key], newVal[key], `${path}/${key}`)
                        }
                    }
                    for (const key of Object.keys(newVal)) {
                        if (!oldVal.hasOwnProperty(key)) {
                            this.serielizeObjectAndAdd(newVal[key], `${path}/${key}`)
                        }
                    }
                }
            }
        } else if (oldVal !== newVal) {
            this._patchDocument.push({ op: "replace", path, value: newVal })
        }
    }
}
